import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "components/app/dialog/dialog";
import ImageUrl from "components/app/image-url/ImageUrl";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";

import { Loader, PrinterCheck, X } from "lucide-react";

import SkeletonMusicLibrariesTable from "pages/account-detail/music-libraries/skeleton/SkeletonMusicLibrariesTable";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { startOfMonth, endOfMonth, eachDayOfInterval, format } from "date-fns";
import { noneProfile } from "assets";
import { Service } from "utils/services";

interface DialogProps {
  loadingPrint: boolean;
  dob: any;
  isDailogTimesheets: boolean;
  itemsDetail: any;
  setIsDailogTimesheets: (value: boolean) => void;
  onUploadSuccess: ({ status }: { status: string }) => void;
  attendanceSetting: any;
  setOpenDrawer: any;
  employeeTimesheetDetail: any;
  setEmployeeTimesheetDetail: any;
  shopEmployeeDetailLoadingState: any;
  setShopEmployeeDetailLoadingState: any;
}
export default function PageReportAttendanceTimesheets({
  attendanceSetting,
  loadingPrint,
  isDailogTimesheets,
  setIsDailogTimesheets,
  itemsDetail,
  dob,
  onUploadSuccess,
  setOpenDrawer,
  setEmployeeTimesheetDetail,
  shopEmployeeDetailLoadingState,
  employeeTimesheetDetail,
  setShopEmployeeDetailLoadingState,
}: DialogProps) {
  const daysInMonth = eachDayOfInterval({
    start: startOfMonth(dob),
    end: endOfMonth(dob),
  });
  // const daysInMonth = eachDayOfInterval({
  //   start: startOfMonth(new Date()),
  //   end: endOfMonth(new Date()),
  // });
  const startDate = startOfMonth(dob);
  const endDate = endOfMonth(dob);

  const formattedStart = format(startDate, "EEE, MMM dd");
  const formattedEnd = format(endDate, "EEE, MMM dd");

  const dateRangeText = `${formattedStart} - ${formattedEnd}`;

  // Format as desired
  // const dateRange = `${startDate} - ${endDate}`;
  const { token } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");

  const totalTardiness = employeeTimesheetDetail?.reduce((sum: any, row: any) => sum + (row.tardiness || 0), 0);
  const totalLateTimeIn = employeeTimesheetDetail?.reduce((sum: any, row: any) => sum + (row.late_in || 0), 0);
  const totalLateEarlyIn = employeeTimesheetDetail?.reduce((sum: any, row: any) => sum + (row.early_in || 0), 0);
  const totalLateTimeOut = employeeTimesheetDetail?.reduce((sum: any, row: any) => sum + (row.out_time || 0), 0);
  const totalLateEarlyOut = employeeTimesheetDetail?.reduce((sum: any, row: any) => sum + (row.early_out || 0), 0);
  const totalal = employeeTimesheetDetail?.reduce((sum: any, row: any) => sum + (row.al || 0), 0);
  const totalsl = employeeTimesheetDetail?.reduce((sum: any, row: any) => sum + (row.sl || 0), 0);
  const totalab = employeeTimesheetDetail?.reduce((sum: any, row: any) => sum + (row.ab || 0), 0);
  const totalRemark = employeeTimesheetDetail?.reduce((sum: any, row: any) => sum + (row.remark || 0), 0);

  // const getShopEmployeeTimesheetDetail = async () => {
  //   setShopEmployeeDetailLoadingState(true);
  //   try {
  //     const url = `${RouteApi.getShopEmployeeTimesheetDetail}token=${token}`;
  //     const data = {
  //       shop_id: shopId,
  //       working_date: itemsDetail?.working_date,
  //       employee_id: itemsDetail?.employee_id,
  //     };
  //     const response = await RequestApi(url, { data });
  //     if (response.status === "success") {
  //       setShopEmployeeDetailLoadingState(false);
  //       setEmployeeTimesheetDetail(response.employee_timesheets);
  //     } else {
  //       console.log(response, "error fetch shop employee ");
  //     }
  //   } catch (error) {
  //     setShopEmployeeDetailLoadingState(false);

  //     AppLog.show({
  //       message: `[getShopEmployeeTimesheetDetail]`,
  //       status: StatusMsg.error,
  //       error,
  //     });
  //   }
  // };
  // useEffect(() => {
  //   getShopEmployeeTimesheetDetail();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isDailogTimesheets]);
  console.log(employeeTimesheetDetail, "employeeTimesheetDetail");
  // console.log(itemsDetail, "itemsDetail");

  return (
    <>
      <div>
        <div className=" max-w-[1300px]  h-[calc(100vh-80px)] py-2 px-0 flex flex-col p-4 ">
          <div>
            <div className="flex items-center justify-between ">
              <div className="flex flex-col  absolute left-3 top-[12px] mb-3 ">
                <div className="font-bold">Attendance Detail Report</div>
                <div>{dateRangeText}</div>
              </div>
              {loadingPrint ? (
                <label
                  htmlFor=""
                  className="hover:border-3 hover:scale-110 transition-all absolute right-3 top-[12px]  duration-300 me-[50px] font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                >
                  <Loader className="animate-spin" />
                </label>
              ) : (
                <label
                  onClick={() => {
                    onUploadSuccess({ status: "print" });
                  }}
                  htmlFor=""
                  className="hover:border-3 hover:scale-110 transition-all absolute right-3 top-[12px]  duration-300 me-[50px] font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                >
                  <PrinterCheck />
                </label>
              )}
            </div>
            <div
              className="absolute flex items-center justify-center right-3 top-[12px] z-40 cursor-pointer rounded-full bg-accent hover:text-accent-foreground lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 border border-gray-300 "
              onClick={() => {
                setIsDailogTimesheets(false);
                setOpenDrawer(null);
                const url = new URL(window.location.href);
                url.searchParams.delete("employee_id");
                window.history.pushState({}, "", url.toString());
              }}
            >
              <X />
            </div>
          </div>
          <div className="flex justify-between items-center">
            {employeeTimesheetDetail?.length > 0 && (
              <>
                <div className="flex flex-col items-start">
                  <p className="text-md font-semibold">{employeeTimesheetDetail[0]?.local_name}</p>
                  <DialogDescription className="text-md">{employeeTimesheetDetail[0]?.position}</DialogDescription>
                  <DialogDescription className="text-md">{employeeTimesheetDetail[0]?.department}</DialogDescription>
                  <DialogDescription className="text-md">
                    W/Hour: {Service.formatTime(employeeTimesheetDetail[0]?.starting_time)} - {Service.formatTime(employeeTimesheetDetail[0]?.ending_time)}
                  </DialogDescription>
                </div>
                <div className="overflow-hidden">
                  <ImageUrl className="rounded-md object-cover h-[100px]" src={!employeeTimesheetDetail[0]?.picture ? noneProfile : employeeTimesheetDetail[0]?.picture} alt="" />
                </div>
              </>
            )}
          </div>
          <ScrollArea className="mt-2 w-full gap-3  pr-[20px]">
            <div className="mt-2 gap-3 overflow-hidden overscroll-auto">
              {shopEmployeeDetailLoadingState ? (
                <SkeletonMusicLibrariesTable />
              ) : (
                <table className="w-full h-full border-b text-center rounded-md border-collapse">
                  <thead className="sticky z-50 top-0 left-0 text-xs text-gray-700  bg-gray-50 dark:bg-[#2c3a52] dark:text-gray-400">
                    <tr>
                      <th rowSpan={2} className="py-4 ps-[55px] border text-start">
                        Day
                      </th>

                      <th colSpan={5} className="py-4 px-5 border whitespace-nowrap">
                        Working Hour
                      </th>
                      <th colSpan={2} className="py-4 px-5 border">
                        Time In
                      </th>
                      <th colSpan={2} className="py-4 px-5 border">
                        Iime Out
                      </th>

                      <th colSpan={4} className="py-4 px-5 border">
                        Leave
                      </th>
                    </tr>

                    <tr className=" text-[11px]">
                      <th className="py-4 px-5 w-[120px]  border text-nowrap">In</th>
                      <th className="py-4 px-5 w-[120px] border text-nowrap">Break Out</th>
                      <th className="py-4 px-5 w-[120px] border text-nowrap">break (In)</th>
                      <th className="py-4 px-5 border w-[120px]">Out</th>

                      <th className="py-4 px-5 border"> Hour </th>
                      {Array.from({ length: 2 }).map((_, i) => (
                        <>
                          {/* Late,Early (Time In) */}
                          <th className="py-4 px-5 border">Late</th>
                          <th className="py-4 px-5 border">Early</th>
                        </>
                      ))}

                      <th className="py-4 px-5 border">AL</th>
                      <th className="py-4 px-5 border">SL</th>

                      <th className="py-4 px-5 border">AB</th>
                      <th className="py-4 px-5 border">Remark</th>
                    </tr>
                  </thead>

                  <tbody className="text-sm ">
                    {daysInMonth.map((date: any, idx: number) => {
                      const days = format(date, "EEE, MMM dd"); // e.g., "Thu, May 01"
                      const item = employeeTimesheetDetail?.[idx] || {}; // fallback if missing

                      const isWeekend = date.getDay() === 0 || date.getDay() === 6; // Sunday or Saturday

                      return (
                        <tr key={idx} className="border-b dark:border-gray-700 border-gray-200 hover:bg-gray-50 dark:hover:bg-[#2c3a52]">
                          <td className={`border px-2 py-4 w-[150px] whitespace-nowrap ${isWeekend ? "text-red-500 font-semibold" : ""}`}>{days}</td>
                          {/* in time  */}
                          <td
                            className={`border text-nowrap px-5  ${
                              !item.starting_time
                                ? "text-gray-500"
                                : !item.in_time
                                ? "text-red-500"
                                : item.in_time > item.starting_time
                                ? item.late_in > attendanceSetting.late_exception
                                  ? "text-red-500"
                                  : item.late_in > 0
                                  ? "text-yellow-500"
                                  : ""
                                : ""
                            }`}
                          >
                            {!item.starting_time ? "OFF" : !item.in_time ? "A" : Service.formatTime(item.in_time)}
                          </td>
                          {/* break out  */}
                          <td className={`border`}>
                            <p
                              className={` text-nowrap
                                         ${
                                           !item.break_starting_time
                                             ? "text-gray-500" // OFF
                                             : !item.break_out_time
                                             ? "text-red-500" // A
                                             : "text-black dark:text-white" // Time present
                                         }
                                       `}
                            >
                              {!item.break_starting_time ? "OFF" : !item.break_out_time ? "A" : Service.formatTime(item.break_out_time)}
                            </p>
                          </td>
                          {/* break in  */}
                          <td className={`border  `}>
                            <p
                              className={` text-nowrap
                                        ${
                                          !item.break_starting_time
                                            ? "text-gray-500" // OFF
                                            : !item.break_in_time
                                            ? "text-red-500" // A
                                            : "text-black dark:text-white" // Valid break_in_time
                                        }
                                           `}
                            >
                              {!item.break_starting_time ? "OFF" : !item.break_in_time ? "A" : Service.formatTime(item.break_in_time)}
                            </p>
                          </td>

                          <td className={`border`}>
                            <p
                              className={` px-5 text-nowrap
                                        
                                         ${
                                           !item.ending_time
                                             ? "text-gray-500" // 1. OFF
                                             : !item.out_time
                                             ? "text-red-500" // 2. A
                                             : item.out_time < item.ending_time
                                             ? item.early_out > attendanceSetting.early_exception
                                               ? "text-red-500" // 4. Exceeds early_exception
                                               : item.early_out > 0
                                               ? "text-yellow-500" // 3. Within early_exception
                                               : ""
                                             : ""
                                         }
  `}
                            >
                              {!item.ending_time ? "OFF" : !item.out_time ? "A" : Service.formatTime(item.out_time)}
                            </p>
                          </td>
                          <td className="border">{item.hour}</td>
                          <td className="border">{item.late_in > 0 ? item.late_in : ""}</td>
                          <td className="border">{item.early_in > 0 ? item.early_in : ""}</td>
                          <td className="border">{item.late_out > 0 ? item.late_out : ""}</td>
                          <td className="border">{item.early_out > 0 ? item.early_out : ""}</td>
                          <td className="border">{item.al > 0 ? item.al : ""}</td>
                          <td className="border">{item.sl > 0 ? item.sl : ""}</td>
                          <td className="border">{item.ab > 0 ? item.ab : ""}</td>

                          <td className="border">{item.remark > 0 ? item.remark : ""}</td>
                        </tr>
                      );
                    })}
                    {/* Total row stays the same */}
                    <tr className="font-semibold bg-gray-50 dark:bg-[#2c3a52] ">
                      <td className="border py-4">Total</td>
                      <td colSpan={2} className="border py-4"></td>

                      <td className="border py-4"></td>
                      <td className="border py-4"></td>
                      <td className="border py-4"></td>
                      <td className="border py-4">{totalLateTimeIn > 0 && totalLateTimeIn}</td>

                      <td className="border py-4"></td>
                      <td className="border py-4"></td>
                      <td className="border py-4"></td>
                      <td className="border py-4"></td>
                      <td className="border py-4"></td>

                      <td className="border py-4"></td>
                      <td className="border py-4"></td>
                    </tr>
                  </tbody>
                </table>
                // </div>
              )}
            </div>
            <ScrollBar orientation="vertical" />
          </ScrollArea>
          <ScrollBar orientation="vertical" />
        </div>
      </div>
    </>
  );
}
